import type { AppPlugin } from '../Plugin';

declare module '../Def' {
    interface AppPluginOptions {
        maxLoadRetryTimes?: number;
    }
}

const DEFAULT_MAX_LOAD_RETRY_TIMES = 2;

export function createRetryLoadingSourceCodePlugin<AdditionalOptions, CustomProps>(): AppPlugin<
    AdditionalOptions,
    CustomProps
> {
    return ({ app }) => {
        let loadRetryCount = 0;

        const maxLoadRetryTimes: number = Math.max(
            DEFAULT_MAX_LOAD_RETRY_TIMES,
            Math.round(app.options.maxLoadRetryTimes ?? 0)
        );

        app.hooks.encounterLoadingSourceCodeFailure.tap('RetryLoadingSourceCodePlugin', () => {
            if (++loadRetryCount < maxLoadRetryTimes) {
                return { retry: true, count: loadRetryCount };
            }
        });
    };
}
